import { Button } from '@/components/Button'

import styles from './DetailsFooter.module.css'

export interface DetailsFooterProps {
  showConfirmAccess: boolean
  onConfirmAccess: () => unknown
  isConfirmAccessPending: boolean
}

export function DetailsFooter({
  showConfirmAccess,
  onConfirmAccess,
  isConfirmAccessPending,
}: DetailsFooterProps) {
  return (
    <div className={styles.root}>
      <div className={styles.actions}>
        {showConfirmAccess && (
          <ConfirmAccessButton
            onConfirmAccess={onConfirmAccess}
            isPending={isConfirmAccessPending}
          />
        )}
      </div>
    </div>
  )
}

interface ConfirmAccessButtonProps {
  onConfirmAccess: () => unknown
  isPending: boolean
}

function ConfirmAccessButton({
  onConfirmAccess,
  isPending,
}: ConfirmAccessButtonProps) {
  return (
    <Button
      label="Confirm Access"
      onPress={onConfirmAccess}
      variant="primary"
      isPending={isPending}
      isDisabled={isPending}
      testId="bookkeeping-manager-details-confirm-access-button"
    />
  )
}
